import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "menu-users",
  "use": "menu-users-usage",
  "viewBox": "0 0 19.74 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19.74 20\" id=\"menu-users\"><title>menu-users</title><path d=\"M15.49,10.44a6.05,6.05,0,0,1-3.36,1,6,6,0,0,1-3.34-1,7.89,7.89,0,0,0-4.4,7.1c0,3.3,15.48,3.26,15.48,0a7.81,7.81,0,0,0-4.38-7.1ZM6.93,5.3a5.2,5.2,0,1,1,10.4,0,5.2,5.2,0,1,1-10.4,0ZM3.49,17.82a.93.93,0,0,0,.06.34c-2-.32-3.42-.94-3.42-1.88a6.84,6.84,0,0,1,3.8-6.14A5.29,5.29,0,0,0,6.65,11a8.78,8.78,0,0,0-3.16,6.8ZM6.07,5.3A6.22,6.22,0,0,1,7.21,1.7a2.43,2.43,0,0,0-.38,0A4.32,4.32,0,0,0,2.55,6,4.32,4.32,0,0,0,6.83,10.4a4.27,4.27,0,0,0,1.52-.28A6.19,6.19,0,0,1,6.07,5.3Zm0,0\" transform=\"translate(-0.13)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/menu-users.svg
// module id = JSBU
// module chunks = 268